import { Button, Col, Form, Input, notification, Row, Select, Switch } from 'antd'
import AppContext from 'context/AppContext'
import React, { useContext, useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

import {
  useOkulKampusleriQuery,
  useOkulSinifSubeleriQuery,
  useSinifDetayQuery,
  useSinifEkleMutation,
} from '../../../../../gql/GeneratedGraphqlTypes'
import Spinner from '../../../../spinner/Spinner'

const ClassesDetailPage = () => {
  const { id } = useParams()
  const [form] = Form.useForm()

  const navigate = useNavigate()
  const [sinifEkleMutation] = useSinifEkleMutation()
  const { okul } = useContext(AppContext)

  const {
    data: sinifData,
    loading: sinifLoading,
    error: sinifError,
  } = useSinifDetayQuery({
    variables: {
      id: parseInt(id ? id : '0'),
    },
    skip: !id,
    fetchPolicy: 'network-only',
  })
  const { data, loading, error } = useOkulKampusleriQuery({
    // <-- refetch ekledik
    variables: {
      sube_id: okul?.id,
    },
    fetchPolicy: 'network-only',
  })
  const {
    data: subeData,
    loading: subeLoading,
    error: subeError,
  } = useOkulSinifSubeleriQuery({
    variables: {
      sube_id: okul?.id,
    },
    fetchPolicy: 'network-only',
  })
  useEffect(() => {
    if (id && sinifData?.sinifDetay) {
      form.setFieldsValue({
        isim: sinifData.sinifDetay.isim || '',
        sube_isim: sinifData.sinifDetay.sube_isim || '',
        mevcut: sinifData.sinifDetay.mevcut || '',
        sinif_kategorisi_id: sinifData.sinifDetay.sinifkategorisi_id || '',
        aktif: sinifData.sinifDetay.aktif || false,
        sube_id: sinifData.sinifDetay.sube_id || '',
      })
    }
  }, [sinifData, form, id])

  if (sinifLoading || loading || subeLoading) {
    return <Spinner color="red" showSpinner={sinifLoading} />
  }

  if (sinifError || error || subeError) {
    notification.error({
      message: 'Hata',
      description: `Bir hata meydana geldi`,
      duration: 6,
    })
  }

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields()

      const input = {
        isim: values.isim || '',
        mevcut: values.mevcut || 0,
        aktif: values.aktif ?? false,
        sube_id: values.sube_id || '',
        sinif_kategorisi_id: values.sinif_kategorisi_id || 0,
      }

      const response = await sinifEkleMutation({
        variables: {
          input: {
            id: id ? parseInt(id) : undefined, // Eğer yeni kayıt ekleniyorsa ID gönderme
            ...input,
          },
        },
      })

      if (response.data?.sinifEkle?.success) {
        notification.success({
          message: 'Başarılı',
          description: response.data?.sinifEkle?.message,
          duration: 6,
        })
        navigate(-1)
      } else {
        notification.error({
          message: 'Hata',
          description: response.data?.sinifEkle?.message || 'Bir hata oluştu',
        })
      }
    } catch (error) {
      notification.error({
        message: 'Hata',
        description: 'Listeyi gönderirken bir hata oluştu.',
        duration: 6,
      })
    }
  }

  return (
    <div className="okul-yonetim-siniflar-detail-page">
      {id ? (
        <div>
          <h1>Sınıf Detay </h1>
          <Form onFinish={handleSubmit} form={form} className="okul-yonetim-detail-form" layout="vertical">
            <Row className="user-info-row" gutter={16}>
              <Col className="user-info-col" span={24}>
                <Col span={8}>
                  <Form.Item label="Sınıf İsmi" name="isim">
                    <Input placeholder="Sınıf ismi giriniz" />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item label="Sınıf Şubesi" name="sinif_kategorisi_id">
                    <Select
                      suffixIcon={<></>}
                      style={{ width: '100%' }}
                      options={subeData?.okulSinifSubeleri?.sinif_subeleri.map((sube) => ({
                        label: sube?.isim,
                        value: sube?.id,
                      }))}
                    />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item label="Kampüs" name="sube_id">
                    <Select
                      suffixIcon={<></>}
                      style={{ width: '100%' }}
                      options={data?.okulKampusleri?.kampusler.map((kampus) => ({
                        label: kampus?.isim,
                        value: kampus?.id,
                      }))}
                    />
                  </Form.Item>
                </Col>
              </Col>
              <Col className="user-info-col" span={24}>
                <Col span={8}>
                  <Form.Item label="Mevcut" name="mevcut">
                    <Input />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item valuePropName="checked" label="Aktif" name="aktif">
                    <Switch />
                  </Form.Item>
                </Col>
              </Col>
            </Row>
            <Button className="back-btn" onClick={() => navigate(-1)}>
              Geri
            </Button>
            <Button className="update-btn" htmlType="submit">
              Güncelle
            </Button>
          </Form>
        </div>
      ) : (
        <div>
          <h1>Sınıf Detay </h1>
          <Form onFinish={handleSubmit} form={form} className="okul-yonetim-detail-form" layout="vertical">
            <Row className="user-info-row" gutter={16}>
              <Col className="user-info-col" span={24}>
                <Col span={8}>
                  <Form.Item
                    label="Sınıf İsmi"
                    name="isim"
                    rules={[{ required: true, message: 'Bu alan zorunludur!' }]}
                  >
                    <Input placeholder="Sınıf ismi giriniz" />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item label="Sınıf Şubesi" name="sinif_kategorisi_id">
                    <Select
                      suffixIcon={<></>}
                      style={{ width: '100%' }}
                      options={subeData?.okulSinifSubeleri?.sinif_subeleri.map((sube) => ({
                        label: sube?.isim,
                        value: sube?.id,
                      }))}
                    />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item label="Kampüs" name="sube_id">
                    <Select
                      suffixIcon={<></>}
                      style={{ width: '100%' }}
                      options={data?.okulKampusleri?.kampusler.map((kampus) => ({
                        label: kampus?.isim,
                        value: kampus?.id,
                      }))}
                    />
                  </Form.Item>
                </Col>
              </Col>
              <Col className="user-info-col" span={24}>
                <Col span={8}>
                  <Form.Item label="Mevcut" name="mevcut" rules={[{ required: true, message: 'Bu alan zorunludur!' }]}>
                    <Input />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item valuePropName="checked" label="Aktif" name="aktif">
                    <Switch />
                  </Form.Item>
                </Col>
              </Col>
            </Row>
            <Button className="back-btn" onClick={() => navigate(-1)}>
              Geri
            </Button>
            <Button className="update-btn" htmlType="submit">
              Kaydet
            </Button>
          </Form>
        </div>
      )}
    </div>
  )
}

export default ClassesDetailPage
